import axios from "axios";
import route from "ziggy-js";
import type { EmailTemplateAttachmentDTO } from "@/types/EmailTemplateAttachments";

type RequestOptions = {
    onSuccess?: (attachment: EmailTemplateAttachmentDTO) => void;
    onError?: (error: string) => void;
};

type DeleteOptions = {
    onSuccess?: () => void;
    onError?: (error: string) => void;
};

export function useEmailTemplateAttachments() {
    const uploadAttachment = async (
        templateId: number,
        file: File,
        options?: RequestOptions,
    ): Promise<void> => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("template_id", String(templateId));

        try {
            const response = await axios.post(
                route("app.email-templates.attachments.store"),
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                },
            );

            options?.onSuccess?.(response.data as EmailTemplateAttachmentDTO);
        } catch (error: any) {
            const message =
                error?.response?.data?.message ||
                error?.response?.data?.errors?.file?.[0] ||
                "Upload failed";
            options?.onError?.(message);
        }
    };

    const deleteAttachment = async (
        id: number,
        options?: DeleteOptions,
    ): Promise<void> => {
        try {
            await axios.delete(
                route("app.email-templates.attachments.destroy", {
                    emailTemplateAttachment: id,
                }),
            );

            options?.onSuccess?.();
        } catch (error: any) {
            const message = error?.response?.data?.message || "Delete failed";
            options?.onError?.(message);
        }
    };

    return {
        uploadAttachment,
        deleteAttachment,
    };
}
